{
  "primer": {
    "eyebrow": "نماز کے اوقات اور قبلہ",
    "headline": "Rhemn کو نماز کے اوقات اور قبلہ کے لیے آپ کے مقام کی ضرورت ہے۔",
    "body": "ہم اسے صرف آپ کی نماز کے اوقات، قبلہ کی سمت اور مقامی موسم کے لیے استعمال کرتے ہیں — اور کچھ نہیں۔",
    "cta": "جاری رکھیں",
    "skip": "ابھی نہیں",
    "skip_body": "نماز کے اوقات اور قبلہ بند رہیں گے۔"
  }
}
